import Cookies from 'js-cookie'

window.customElements.define('recently-viewed-products', class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super()
    this.container = this.querySelector('section')
    this.swiperTemplate = this.querySelector('template.recently-viewed-products-swiper-template')
    this.slideTemplate = this.querySelector('template.recently-viewed-products-slide-template')
    this.productHandles = this.getRecentlyViewed()
    this.products = new Array(this.productHandles.length)
    this.init()
  }

  getRecentlyViewed() {
    const products = Cookies.get('recently-viewed-products')
    return products ? JSON.parse(products) : []
  }

  async init() {
    await this.fetchProducts()
    this.render()
    this.addRecentlyViewed()
  }

  async fetchProducts() {
    if (!this.productHandles.length) return
    return Promise.all(this.productHandles.map(this.fetchProduct.bind(this)))
  }

  async fetchProduct(productHandle, index) {
    try {
      let res = await fetch(`/products/${productHandle}.js`)
      res = await res.json()
      this.products.splice(index, 1, res)
    } catch (err) {
      console.error(err)
    }
  }

  render() {
    const swiperContainer = this.swiperTemplate.content.cloneNode(true)
    const slidesContainer = swiperContainer.querySelector('.swiper-wrapper')
    const badgeTags = ['Sale', 'New Arrivals', 'Best Seller']

    let heading = document.createElement('template')
    heading.innerHTML = `
      <div class="recently-viewed-products__product-carousel-heading">
        <h2>Recently Viewed</h2>
      </div>
    `.trim()
    heading = heading.content

    this.products.forEach(product => {
      const slideContainer = this.slideTemplate.content.cloneNode(true)

      slideContainer.querySelector('.card').href = product.url

      const slideBadge = slideContainer.querySelector('.card__badge')
      const badgeTag = product.tags.find(tag => badgeTags.includes(tag))
      if (badgeTag) {
        const badgeHandle = badgeTag.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
        slideBadge.classList.add(`card__badge--${badgeHandle}`)
        slideBadge.textContent = badgeTag
      } else {
        slideBadge.remove()
      }

      if (product.featured_image) {
        const imageUrl = new URL(product.featured_image, window.location.origin)
        const ext = imageUrl.pathname.lastIndexOf('.')
        imageUrl.pathname = `${imageUrl.pathname.slice(0, ext)}_200x160${imageUrl.pathname.slice(ext)}`
        const image = document.createElement('img')
        image.src = imageUrl.toString()
        slideContainer.querySelector('.card__image').appendChild(image)
      }

      slideContainer.querySelector('.card__title').textContent = product.title

      const price = slideContainer.querySelector('.card__price')
      price.lastChild.textContent = Shopify.formatMoney(product.price)
      if (product.compare_at_price) {
        price.querySelector('.card__compare-price').textContent = Shopify.formatMoney(product.compare_at_price)
      } else {
        price.querySelector('.card__compare-price-wrap').remove()
      }

      slideContainer.querySelector('.card__button button').dataset.product = product.handle
      slidesContainer.appendChild(slideContainer)
    })

    this.container.innerHTML = ''
    this.container.append(heading, swiperContainer)
  }

  addRecentlyViewed() {
    if (!window.location.pathname.includes('/products/')) return
    let handles = this.productHandles
    const currentHandle = window.location.pathname.substring(window.location.pathname.lastIndexOf('/products/') + 10)
    if (handles.some(h => h === currentHandle)) handles = handles.filter(h => h !== currentHandle)
    handles.unshift(currentHandle)
    if (handles.length > 5) handles.pop()
    this.productHandles = handles
    Cookies.set('recently-viewed-products', JSON.stringify(this.productHandles))
  }
})
